import React, {useState,useCallback} from "react";
import { Card, Button } from "react-bootstrap";
import './ProductSlider.css'
import { useSelector, useDispatch } from "react-redux";
import font from '../fonts/Aboreto/Aboreto-Regular.ttf'
// import cartSlice, { addToCart } from './cartSlice';
// import { addItem, removeItem } from './storeByGPT'
import { Store } from './store/store';
import Cart from './cart';




const ProductCard = ({product}) => {
    const dispatch = useDispatch()
      const handleClick = useCallback((item) => {
        Store.dispatch({type: "ITEM_ADDED",item });
        console.log(Store.getState());
      }, [dispatch])
    const [display, setDisplay] = useState(null);
  return (
    <div style={{backgroundColor: "black",fontFamily: {font}}}>
      <Card style={{ width: "inherit",backgroundColor: "black",color: "white"}}>
        <div className='container' key={product.id} 
        onMouseOver={()=>{setDisplay(product.id)}} onMouseLeave={()=>{setDisplay(null)}}>

          <Card.Img src={product.image} alt={product.name} width="100%" height="auto" className='image'
          onMouseOver={()=>{setDisplay(product.id)}} onMouseLeave={()=>{setDisplay(null)}}>
          </Card.Img>
          <div className='button container'>
          {display === product.id && (
            <a 
            onClick={()=> handleClick(product)}
             style={{transition: "all 1s ease-in-out"}}
            className="btn addToCart" >Add to Cart</a>
            )}
            </div>
            </div>
        <Card.Body>
          <Card.Title>{product.title}</Card.Title>
          <Card.Text>
          {product.discountedPrice ? (
            <>
              <p className="original-price" style={{fontFamily: "font"}} ><del>${product.price}</del> <span className='mx-2'> ${product.discountedPrice}</span></p>
            </>
          ) : (
            <>
            <p style={{fontFamily: "font"}}>${product.price}</p>
            </>
            )}
          </Card.Text>
          <div className="product-actions">
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProductCard;